<template>
    <div class="container">
        <section class="section">
            <div class="column is-10-desktop is-offset-1-desktop is-12-tablet">
                <!-- Month Selector - Improved -->
                <div class="box has-background-light mb-5">
                    <div class="is-flex is-justify-content-center is-align-items-center">
                        <b-button
                            class="mr-4"
                            type="is-primary"
                            icon-left="chevron-left"
                            :disabled="local.loading"
                            @click="local.monthShift = local.monthShift - 1"
                        />
                        <h2 class="title is-3 mb-0">{{ currentMonthLabel }}</h2>
                        <b-button
                            type="is-primary"
                            class="ml-4"
                            icon-left="chevron-right"
                            :disabled="local.loading"
                            @click="local.monthShift = local.monthShift + 1"
                        />
                    </div>
                </div>

                <!-- Billing Breakdown Items -->
                <div class="billing-container">
                    <!-- Completed Sessions -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="check-circle" type="is-success" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">
                                    Completed Sessions
                                </p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{
                                    local.sessionReport.completedSessionCount
                                }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-success">
                                    {{ local.sessionReport.completedSessionCount * local.defaultPrice }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Late Cancels -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="clock-alert-outline" type="is-warning" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">Late Cancels</p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{
                                    local.sessionReport.lateCancelSessionCount
                                }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-success">
                                    {{ local.sessionReport.lateCancelSessionCount * local.defaultPrice }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Hybrid Sessions -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="link-variant" type="is-info" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">
                                    Hybrid Sessions
                                </p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{ local.sessionReport.hybridSessions }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-success">
                                    {{ local.hybridSesssionSum }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Voucher Sessions -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="ticket-confirmation" type="is-primary" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">
                                    Voucher Sessions
                                </p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{ local.sessionReport.voucherSessions }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-success">
                                    {{ local.voucherSessionSum }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- CAC Sessions -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="account-cash" type="is-danger" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">CAC Sessions</p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{ local.sessionReport.cacSessions }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-grey">
                                    {{ local.sessionReport.cacSessions * 0 }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Sessions done for other coaches -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="account-arrow-right" type="is-link" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">
                                    Sessions done for other coaches
                                </p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{
                                    local.sessionReport.sessionsDoneForOtherCoaches
                                }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-success">
                                    {{ local.forOtherCoachesSum }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Sessions done by other coaches -->
                    <div class="box billing-row">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-1-desktop is-2-mobile has-text-centered">
                                <b-icon icon="account-arrow-left" type="is-link" size="is-medium"></b-icon>
                            </div>
                            <div class="column is-5-desktop is-4-mobile">
                                <p class="has-text-weight-semibold is-size-5-desktop is-size-6-mobile">
                                    Sessions done by other coaches
                                </p>
                            </div>
                            <div class="column is-2-desktop is-2-mobile has-text-centered">
                                <span class="tag is-medium is-light">{{
                                    local.sessionReport.sessionsDoneByOtherCoaches
                                }}</span>
                            </div>
                            <div class="column is-4-desktop is-4-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-4-desktop is-size-5-mobile has-text-success">
                                    {{ local.byOtherCoachesHigherPayGradeSum + local.byOtherCoachesLowerPayGradeSum }} €
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- TOTAL - Make it stand out! -->
                    <div class="box billing-total has-background-primary mt-5">
                        <div class="columns is-mobile is-vcentered mb-0">
                            <div class="column is-7-desktop is-6-mobile">
                                <p class="has-text-weight-bold is-size-3-desktop is-size-4-mobile has-text-white">
                                    <b-icon icon="currency-eur" class="mr-2" custom-class="has-text-white"></b-icon>
                                    TOTAL BILLABLE AMOUNT
                                </p>
                            </div>
                            <div class="column is-5-desktop is-6-mobile has-text-right">
                                <p class="has-text-weight-bold is-size-2-desktop is-size-3-mobile has-text-white">
                                    {{ local.totalBillableSessions }} €
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { sharedState } from '../../../framework/state';
import { getReportSessionsCount } from '../../client/session_client';
import { getResources } from '../../../framework/client/resource';
import { ApplicationResource } from '../../../../common/application/enumeration/ApplicationResource';
import {
    byOtherCoachesHigherPayGradeSum,
    forOtherCoachesSum,
    totalBillableSessions,
    getBaseSessionsCount,
    hybridSesssionPrice,
    voucherSessionPrice,
    byOtherCoachesLowerPayGradeSum,
    defaultPrice,
    higherPrice,
} from '../../../../common/application/service/calculator';
import { Coach } from '../../../../common/application/model/coach';
import moment, { Moment, utc } from 'moment';
import { shiftMonth } from '../../../../browser/application/service/helper_service';
import { SessionReport } from '../../../../common/application/model/session-report';

@Component({
    components: {},
})
export default class BillingBreakdown extends Vue {
    @Prop(String) readonly coachId!: string;

    shared = sharedState;
    local = {
        selectedCoach: {
            id: undefined as undefined | string,
        },
        totalBillableSessions: 0,
        monthShift: 0,
        loading: false,
        sessionReport: {} as SessionReport,
        voucherSessionSum: 0,
        defaultPrice,
        higherPrice,
        hybridSesssionSum: 0,
        forOtherCoachesSum: 0,
        byOtherCoachesHigherPayGradeSum: 0,
        byOtherCoachesLowerPayGradeSum: 0,
        baseSum: 0,
    };

    async mounted() {
        this.local.selectedCoach.id = this.coachId;
        await this.loadAsyncData();
    }

    async loadAsyncData() {
        this.local.loading = true;
        this.local.sessionReport = await this.getSessionReport();
        const coachParameters = new Map<string, string>([['userId', this.shared.context.userId]]);
        const coach = (await getResources<Coach>(ApplicationResource.COACH, -1, coachParameters))[0] ?? {};
        const currentCoachHigherPayGrade = coach?.higherPayGrade ?? false;
        this.local.totalBillableSessions = totalBillableSessions(this.local.sessionReport, currentCoachHigherPayGrade);

        this.local.baseSum =
            getBaseSessionsCount(this.local.sessionReport) *
            (this.local.sessionReport.higherPayGrade ? higherPrice : defaultPrice);
        this.local.forOtherCoachesSum = forOtherCoachesSum(this.local.sessionReport, currentCoachHigherPayGrade);
        this.local.byOtherCoachesHigherPayGradeSum = byOtherCoachesHigherPayGradeSum(this.local.sessionReport);
        this.local.byOtherCoachesLowerPayGradeSum = byOtherCoachesLowerPayGradeSum(this.local.sessionReport);
        this.local.hybridSesssionSum = this.local.sessionReport.hybridSessions * hybridSesssionPrice;
        this.local.voucherSessionSum = this.local.sessionReport.voucherSessions * voucherSessionPrice;
        this.local.loading = false;
    }

    async getSessionReport() {
        console.log(this.local.selectedCoach);
        console.log(this.selectedMonthInUtc());
        const parameters = new Map<string, any>([
            ['coachId', this.local.selectedCoach.id],
            ['startDateOfMonth', this.selectedMonthInUtc().startOf('month').toISOString()],
            ['endDateOfMonth', this.selectedMonthInUtc().endOf('month').toISOString()],
        ]);

        let queryString = 'date >= {startDateOfMonth} AND date <= {endDateOfMonth}';

        return await getReportSessionsCount(parameters, queryString);
    }

    selectedMonthInUtc(): Moment {
        return shiftMonth(utc(), this.local.monthShift);
    }

    get currentMonthLabel(): string {
        return this.$t('enum.month.' + this.selectedMonthInUtc().month()).toString();
    }

    @Watch('local.monthShift')
    async monthShiftChanged() {
        await this.loadAsyncData();
    }
}
</script>

<style scoped>
.billing-container {
    margin-top: 2rem;
}

.billing-row {
    margin-bottom: 1rem;
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
}

.billing-row:hover {
    transform: translateX(8px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    border-left-color: #3273dc;
}

.billing-total {
    border: 3px solid #00d1b2 !important;
    box-shadow: 0 8px 24px rgba(50, 115, 220, 0.3);
    animation: pulse-border 2s infinite;
}

@keyframes pulse-border {
    0%,
    100% {
        box-shadow: 0 8px 24px rgba(50, 115, 220, 0.3);
    }
    50% {
        box-shadow: 0 8px 32px rgba(50, 115, 220, 0.5);
    }
}

.has-text-success {
    color: #48c774 !important;
}

/* Mobile adjustments */
@media screen and (max-width: 768px) {
    .billing-row:hover {
        transform: translateX(4px);
    }
}
</style>
